import type { ClerkProvider } from "@clerk/react";
import type * as React from "react";

import { paths } from "@/paths";

// Auth itself has no local UI here — every sign-in/sign-up/waitlist flow is
// hosted by the hub and reached by URL, same as calendar/docs/community.
// VITE_HUB_URL is the platform-wide name for the hub's origin (matches every
// sibling app).
const HUB_URL = (import.meta.env.VITE_HUB_URL ?? "https://scoutingops.com") as string;

type ClerkProviderProps = Omit<React.ComponentProps<typeof ClerkProvider>, "children">;

export const providerProps = {
  publishableKey: import.meta.env.VITE_CLERK_PUBLISHABLE_KEY!,
  afterSignOutUrl: paths.home,
  signInFallbackRedirectUrl: paths.studio,
  signInUrl: `${HUB_URL}/auth/sign-in`,
  signUpUrl: `${HUB_URL}/auth/waitlist`,
} satisfies ClerkProviderProps;
